import { Page } from '../Components/layout/Page';
import config from '../config';

export const DesignAgentMovedPage = () => (
    <Page>
        <Page.Title>Design Agent has moved</Page.Title>
        <Page.Content>
            <p>Design Agent now has its own playground.</p>
            <a href={config.designAgentPlaygroundUrl}>Open the Design Agent playground</a>
        </Page.Content>
    </Page>
);
